import { render, staticRenderFns } from "./GerdauCrudMetaView.vue?vue&type=template&id=641cb992&scoped=true&"
import script from "./GerdauCrudMetaView.vue?vue&type=script&lang=js&"
export * from "./GerdauCrudMetaView.vue?vue&type=script&lang=js&"
import style0 from "./GerdauCrudMetaView.vue?vue&type=style&index=0&id=641cb992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cb992",
  null
  
)

export default component.exports